import { SizableText, Stack, XStack, YStack } from '@mythical/ui'
import { StarFull } from '@tamagui/lucide-icons'
import { LandingMemberQuote as LandingMemberQuoteType } from 'app/blocks/landing/landing-member-quote'
import { PatternBackground } from 'app/components/primitive/PatternBackground'
import { Container } from 'app/components/structure/Container'
import Section from 'app/components/structure/Section'
import React from 'react'
import { SolitoImage } from 'solito/image'
interface LandingMemberQuoteBlockProps {
  block: LandingMemberQuoteType
}

const Stars = ({ count = 5 }: { count?: number }) => (
  <XStack gap="$1" jc="center">
    {Array.from({ length: count }).map((_, i) => (
      <StarFull
        color="$brandPurple"
        h={24}
        key={i}
        w={24}
        $gtSm={{ w: 40, h: 40 }}
      />
    ))}
  </XStack>
)

export const LandingMemberQuoteBlock: React.FC<
  LandingMemberQuoteBlockProps
> = ({ block }) => {
  const { quote, memberName, memberImage } = block

  if (!quote || !memberName) return null

  return (
    <Section paddedX>
      <Container
        ai="center"
        bg="$brandPink"
        br="$3"
        variant="full"
        gap="$8.5"
        overflow="hidden"
        position="relative"
        px="$3.5"
        py={112}
        $gtSm={{
          p: 80,
        }}
      >
        <PatternBackground color='#F8B1E3' tileSize={370} />

        <YStack gap="$3.5">
          <Stars count={5} />

          <SizableText
            size="$10.5"
            color="$brandPurple"
            fontFamily="$condensed"
            fontWeight="400"
            letterSpacing={0.56}
            textAlign="center"
            textTransform="uppercase"
            $gtSm={{
              size: '$13',
              letterSpacing: 1.04,
            }}
          >
            {quote}
          </SizableText>
        </YStack>

        <XStack ai="center" gap="$5">
          <Stack
            ai="center"
            jc="center"
            borderColor="$backdrop"
            borderWidth={2}
            br={100}
            h={66}
            overflow="hidden"
            w={66}
          >
            {memberImage?.sizes?.square?.url ? (
              <SolitoImage
                alt={memberName}
                src={memberImage.sizes.square.url}
                fill
              />
            ) : (
              <SizableText size="$6" color="$brandPurple">
                {memberName
                  .split(' ')
                  .map((n) => n[0])
                  .join('')
                  .toUpperCase()}
              </SizableText>
            )}
          </Stack>

          <YStack gap="$1.5" flexShrink={1}>
            <SizableText size="$6" color="$brandPurple" fontWeight="700">
              {memberName}
            </SizableText>
            <SizableText size="$4" color="$brandPurple" fontWeight="500">
              Mythical Society Member
            </SizableText>
          </YStack>
        </XStack>
      </Container>
    </Section>
  )
}
